import React from 'react'
import PropTypes from 'prop-types'

import { PRODUCT_TYPE_IMAGES } from '../images/product-types'

import '../styles/ProductTypeIllustration.scss'

export default function ProductTypeIllustration({ productType }) {
  const illustration = PRODUCT_TYPE_IMAGES[productType]

  if (!illustration) {
    return null
  }

  return (
    <div className="ProductTypeIllustration">
      <img src={illustration} alt="" width="240" height="171" />
    </div>
  )
}

ProductTypeIllustration.propTypes = {
  productType: PropTypes.string.isRequired,
}
